import React, { FC } from 'react';
import { StyledMonthDetails } from 'organisms/InvoiceChart/InvoiceChart.styles';
import { Box, Typography } from '@mui/material';
import { currencyFormatter } from 'utils/helpers/currencyFormatter';

export const InvoiceDetails: FC<{
  invoice_total: number;
  paid_invoice_total: number;
  currency: string;
}> = ({ invoice_total, paid_invoice_total, currency }) => (
  <StyledMonthDetails sx={{ position: 'unset !important' }}>
    <Box>
      <Typography variant="body2">Total:</Typography>
      <Typography variant="body2">
        {currencyFormatter(Number(invoice_total ?? 0), currency)}
      </Typography>
    </Box>
    <Box>
      <Typography variant="body2">Paid:</Typography>
      <Typography variant="body2">
        {currencyFormatter(Number(paid_invoice_total ?? 0), currency)}
      </Typography>
    </Box>
  </StyledMonthDetails>
);
